import { isDecimal, isEmail, isNumeric, isURL } from 'validator';
import { isValidDate } from './date';

var decimal = function decimal(value) {
  return value && !isDecimal(String(value)) ? 'This is not a valid decimal number' : undefined;
};

var date = function date(value) {
  return value && !isValidDate(String(value)) ? 'This date is invalid' : undefined;
};

var email = function email(value) {
  return value && !isEmail(String(value)) ? 'This email address is invalid' : undefined;
};

var nonNegativeNumber = function nonNegativeNumber(value) {
  return value && +value < 0 ? 'Non-negative number required' : undefined;
};

var numeric = function numeric(value) {
  return value && !isNumeric(String(value)) ? 'This is not a valid integer number' : undefined;
};

var number = function number(value) {
  return value && !isNumeric(String(value), {
    no_symbols: true
  }) ? 'This is not a valid number' : undefined;
};

var required = function required(value) {
  return !value || Array.isArray(value) && !value.length || value === '' ? 'This field cannot be empty' : undefined;
};

var url = function url(value) {
  return value && !isURL(String(value)) ? 'This URL is invalid' : undefined;
};

var username = function username(value) {
  var message = [];

  if (!value || value.length < 4) {
    message.push('Must be at least 4 characters');
  } else {
    if (value.length > 31) {
      message.push('Must be less than 32 characters');
    }

    if (/[A-Z]/.test(value)) {
      message.push('Must be all lowercase');
    }

    if (!/^[\w0-9._-]*$/.test(value)) {
      message.push('Only underscore(_), dash(-) and dot(.) is allowed');
    }
  }

  return message.length ? message.join(' ') : undefined;
};

var password = function password(value, values) {
  var _ref = values || {},
      changePassword = _ref.changePassword;

  return changePassword ? !value || value.length < 8 ? 'Must be at least 8 characters' : undefined : undefined;
};

var text = function text(value) {
  return value.length > 255 ? 'Must be less than 256 characters' : undefined;
};

export default {
  date: date,
  decimal: decimal,
  email: email,
  nonNegativeNumber: nonNegativeNumber,
  number: number,
  numeric: numeric,
  password: password,
  required: required,
  text: text,
  url: url,
  username: username
};